export default "__VITE_ASSET__DlqWIb8a__"